unit UZeitartList;

interface

uses
  System.Contnrs, UZeitartModel, Js, UEssentialHelper;

type
  TZeitartList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    function GetItem(i: Integer): TZeitartModel;
    procedure PropertyChanged;
    procedure SetValues(json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetOnPropertyChanged(const Value: TCallback);
  public
    function ToString: string; override;
    procedure Add(item: TZeitartModel);
    procedure GetByIds(url: string; zeitartIds: string);
    property Items[i: Integer]: TZeitartModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged write SetOnPropertyChanged;
  end;

implementation

uses
  System.SysUtils, System.Classes, WebLib.JSON, WebLib.REST;

{ TZeitartList }

procedure TZeitartList.Add(item: TZeitartModel);
begin
  inherited Add(item);
end;

procedure TZeitartList.GetByIds(url, zeitartIds: string);
var obj: TJsonObject;
    helper: string;
    client: TRestClient;
  procedure Response(sender: TObject; aResponse: string);
  var jso: TJsObject;
  begin
    jso:=TJsJson.parseObject(aResponse);
    Self.Clear;
    if jso['value']<>nil then
      Self.SetValues(string(jso['value']));
    Self.PropertyChanged;
  end;
begin
  obj:=TJsonObject.Create;
  obj.AddPair('ZeitartIds',zeitartIds);
  helper:=obj.ToString;
  obj:=TJsonObject.Create;
  obj.AddPair('value',helper);
  client:=TRestClient.Create(nil);
  client.OnResponse:=Response;
  client.HttpsPost(url+'/ZeitartService/GetByIds','application/json',obj.ToString);
  client.Free;
end;

function TZeitartList.GetItem(i: Integer): TZeitartModel;
begin
  Result:=inherited GetItem(i) as TZeitartModel;
end;

procedure TZeitartList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TZeitartList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TZeitartList.SetValues(json: string);
var obj: TJsObject;
begin
  obj:=TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

function TZeitartList.ToString: string;
var lst: TStringList;
    i: Integer;
begin
  lst:=TStringList.Create;
  lst.Add('Count: '+IntToStr(Self.Count));
  for i:=0 to Self.Count-1 do
    lst.Add('Item'+IntToStr(i)+': '+Self.Items[i].ToString);
  Result:=lst.Text;
  lst.Free;
end;

procedure TZeitartList.SetValues(obj: TJsObject);
var i, count: Integer;
begin
  Self.Clear;
  if obj['Count']<>nil then begin
    count:=StrToInt(string(obj['Count']));
    for i:=0 to count-1 do
      if obj['Item'+IntToStr(i)]<>nil then
        Self.Add(TZeitartModel.Create(string(obj['Item'+IntToStr(i)])));
  end;
end;

end.
